export enum EApi {
  REQUEST_SIGNUP_OTP = 'REQUEST_SIGNUP_OTP',
  AUTHENTICATE_USER = 'AUTHENTICATE_USER',
  FETCH_PRE_SIGN_UP_APP_CONFIG = 'FETCH_PRE_SIGN_UP_APP_CONFIG',
  GET_USER_DETAILS = 'GET_USER_DETAILS',
  GET_TOURNAMENTS_LIST = "GET_TOURNAMENTS_LIST",
  GET_PWA_HOME_SCREEN = "GET_PWA_HOME_SCREEN",
  GET_TOURNAMENT_DETAILS = "GET_TOURNAMENT_DETAILS",
  GET_LEADERBOARD_DETAILS = "GET_LEADERBOARD_DETAILS",
  REGISTER_TOURNAMENT = "REGISTER_TOURNAMENTS",
  GET_GAME_CONFIG = "GET_GAME_CONFIG",
  GET_TOURNAMENTS_HISTORY = "GET_TOURNAMENTS_HISTORY",
  SET_USER_LOCATION = "SET_USER_LOCATION",
  GET_PWA_POST_GAME_WD_DATA_EVENT = "GET_PWA_POST_GAME_WD_DATA_EVENT",
  INITIATE_WITHDRAW = "INITIATE_WITHDRAW",
  WITHDRAW_BREAKDOWN = "WITHDRAW_BREAKDOWN",
  PROCESS_WITHDRAWAL = "PROCESS_WITHDRAWAL",
  PAYOUT_STATUS_SCREEN = "PAYOUT_STATUS_SCREEN",
  GET_WALLET_SCREEN_DATA = "GET_WALLET_SCREEN_DATA",
  GET_SAVED_WITHDRAWAL_MODES = "GET_SAVED_WITHDRAWAL_MODES",
  ADD_UPI_ID = "ADD_UPI_ID",
  SUBMIT_BANK_DETAILS = "SUBMIT_BANK_DETAILS",
  GET_WITHDRAWAL_SCREEN_BOTTOMSHEET = "GET_WITHDRAWAL_SCREEN_BOTTOMSHEET",
  GET_KYC_LANDING_DATA = "GET_KYC_LANDING_DATA",
  INITIALIZE_DIGILOCKER_KYC = "INITIALIZE_DIGILOCKER_KYC",
  COMPLETE_DIGILOCKER_KYC = "COMPLETE_DIGILOCKER_KYC",
}

export interface RootApiResponseWithData<T> {
  en: EApi;
  response: {
    // bankDetails: any;
    success: boolean;
    error?: string;
    message?: string;
    errorType?: string;
    data?: T;
    userDetail?: T;
    widgets?: T;
    entities?: any;
    tournament?: any;
    externalMessage?: string;
    noResultText?: string;
  };
}

export interface RootApiResponseExtends<T> {
  en: EApi;
  response: {
    success: boolean;
    error?: string;
  } & Partial<T>;
}

export interface IBaseUrl {
  url: string;
  en: EApi;
}